// @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
import React, { memo, useCallback, useEffect, useMemo, useState } from 'react'
import moment from 'moment'
import classNames from 'classnames'
import { useSelector } from 'react-redux'
// @ts-expect-error TS7016 -- MIGRATION: not approved, fix when encountered
import { SvgIcon, Tooltip } from 'ui_kit_qmd'
import { generateTableList } from '../../../utils/VisitsCommon'
import inactiveFilterIcon from '../../../images/common/FilterInactive.png'
import activeFilterIcon from '../../../images/common/activeFilter.png'
import { visitTableTitles } from '../../../utils/constants'
import './VisitTableColumnTitles.scss'

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
const formatDate = (date) => moment(date).format('MMM DD YYYY')
export const VisitTableColumnTitles = memo(
  ({
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    type,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    tableView,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    setVisitTypesFilterRow,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    setStatusFilterRow,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    visitTypesFilterRow,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    closeRemarks,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    statusFilterRow,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    stateFilter,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    dispatchFilter,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    visitsList,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    setTagFilterRow,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    tagFilterRow,
  }) => {
    // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
    const loading = useSelector((state) => state.visitsPage.loading)

    const [isFilterOpen, setFilterOpen] = useState(false)
    const [visitsListToShow, setVisitsListToShow] = useState([])
    const [isTableWithScroll, setIsTableWithScroll] = useState(false)
    console.log('visitsListToShow', visitsListToShow)

    const showFilter = () => {
      setFilterOpen(!isFilterOpen)
    }

    // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
    const closeFilter = (event) => {
      if (event?.target?.classList) {
        const classList = event?.target?.classList
        const isIcon = classList.contains('svg-component-icon') || classList.contains('svg-component-path')

        if (!isIcon) {
          setFilterOpen(false)
        }
      } else {
        setFilterOpen(false)
      }
    }

    const { fromDate, toDate, isDateUpdated } = stateFilter.date
    const tooltipContent = `From ${formatDate(fromDate)} to ${formatDate(toDate)}`

    useEffect(() => {
      const tableBodyContainer = document.querySelector('.visits-page-body-table')
      if (!tableBodyContainer) return
      if (tableBodyContainer.clientHeight !== tableBodyContainer.scrollHeight) {
        setIsTableWithScroll(true)
      } else {
        setIsTableWithScroll(false)
      }
    }, [loading])

    useEffect(() => {
      switch (type) {
        case 'upcomingCollapsed':
          // @ts-expect-error TS2554 -- MIGRATION: not approved, fix when encountered
          const newTitlesUpcomingToGenerate = generateTableList('upcomingCollapsed', true).map((item) =>
            item.name === visitTableTitles.VISIT ? { ...item, isFilterActive: !!visitTypesFilterRow } : item,
          )
          setVisitsListToShow(newTitlesUpcomingToGenerate)
          break
        case 'pastCollapsed':
          // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
          const newTitlesPastToGenerate = generateTableList('pastCollapsed', true, true).map((item) =>
            item.name === visitTableTitles.VISIT ? { ...item, isFilterActive: !!visitTypesFilterRow } : item,
          )
          setVisitsListToShow(newTitlesPastToGenerate)
          break
        default:
          break
      }
    }, [type])

    const visitTableColumnTitleContainerStyle = useMemo(
      () => ({ paddingRight: isTableWithScroll ? '0.25rem' : 0 }),
      [isTableWithScroll],
    )
    // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
    const onOpenShowFilterSettings = (titleName) => {
      // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
      setVisitsListToShow((prev) =>
        prev.map((visitObj) =>
          // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
          visitObj.name === titleName ?
            // @ts-expect-error TS2698 -- MIGRATION: not approved, fix when encountered
            { ...visitObj, isShowFilterComponent: true }
            // @ts-expect-error TS2698 -- MIGRATION: not approved, fix when encountered
          : { ...visitObj, isShowFilterComponent: false },
        ),
      )
    }
    const onCloseFilterSettings = useCallback(
      // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
      (e) => {
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        const openedFilter = visitsListToShow.find((t) => t?.isShowFilterComponent)
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        if (e?.target?.id === `filterImg${openedFilter?.name}`) {
          e?.stopPropagation()
        }
        if (!(e?.target?.parentElement?.classList?.[0] === 'loading-container')) {
          // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
          setVisitsListToShow((prev) => prev.map((visitObj) => ({ ...visitObj, isShowFilterComponent: false })))
        }
      },
      [visitsListToShow],
    )
    // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
    const correctFilterCallback = (titleName, newFilterRow) => {
      // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
      setVisitsListToShow((prev) =>
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        prev.map((visit) => (visit.name === titleName ? { ...visit, isFilterActive: !!newFilterRow } : visit)),
      )
      switch (titleName) {
        case visitTableTitles.VISIT:
          if (visitTypesFilterRow || newFilterRow) {
            closeRemarks()
          }
          setVisitTypesFilterRow(newFilterRow)
          break
        case visitTableTitles.STATUS:
          if (statusFilterRow || newFilterRow) {
            closeRemarks()
          }

          setStatusFilterRow(newFilterRow)
          break
        case visitTableTitles.TAGS:
          if (tagFilterRow || newFilterRow) {
            closeRemarks()
          }
          setTagFilterRow(newFilterRow)
          break
        default:
          return () => {}
      }
    }

    return (
      <div
        className={classNames('visits-page-toolbox-container', { 'is-with-border': !visitsList?.length })}
        style={visitTableColumnTitleContainerStyle}>
        {visitsListToShow.map(
          ({
            name,
            additionalContainerStyle,
            additionalSpanStyle,
            isWithFilter,
            FilterComponent,
            isShowFilterComponent,
            isFilterActive,
            VisitsFilter,
            filterSvgIcon,
            hasFilter,
          }) => (
            <div key={name} className='visits-page-table-column-title-item-container' style={additionalContainerStyle}>
              <span className='visits-page-table-column-title-item' style={additionalSpanStyle}>
                {name}
              </span>
              {hasFilter ?
                <>
                  <Tooltip className='visits-tooltip' content={tooltipContent} disabled={!isDateUpdated}>
                    <span className='visits-filter-icon-container'>
                      <SvgIcon
                        onClick={showFilter}
                        className={classNames('visits-filter-icon', { 'filter-icon-active': isDateUpdated })}
                        name={filterSvgIcon}
                      />
                    </span>
                  </Tooltip>
                  {isFilterOpen && VisitsFilter ?
                    // @ts-expect-error TS2604 -- MIGRATION: not approved, fix when encountered
                    <VisitsFilter
                      stateFilter={stateFilter}
                      dispatchFilter={dispatchFilter}
                      closeFilter={closeFilter}
                      closeRemarks={closeRemarks}
                    />
                  : null}
                </>
              : null}
              {isWithFilter ?
                <>
                  <input
                    type='image'
                    src={isFilterActive ? activeFilterIcon : inactiveFilterIcon}
                    onClick={() => onOpenShowFilterSettings(name)}
                    className='visits-page-table-column-title-filter'
                    alt='filterIcon'
                    id={`filterImg${name}`}
                  />
                  {FilterComponent && isShowFilterComponent ?
                    // @ts-expect-error TS2604 -- MIGRATION: not approved, fix when encountered
                    <FilterComponent
                      setVisitsListToShow={setVisitsListToShow}
                      onCloseFilterSettings={onCloseFilterSettings}
                      loading={loading}
                      // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
                      setFilterRow={(newFilterRow) => correctFilterCallback(name, newFilterRow)}
                      tableView={tableView}
                    />
                  : null}
                </>
              : null}
            </div>
          ),
        )}
      </div>
    )
  },
)
